import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import { Observable, observable, throwError, of } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from '../../../store/state/app.state';
import { CURRENT_ENVIROMENT, SERVICE_END_POINT } from '../../../shared';
import { STORE_VAL } from 'src/app/shared/constants/store-val.constant';

const httpOptions = {
headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
providedIn: 'root'
})

export class StartQuoteService {

private endPoints = SERVICE_END_POINT[CURRENT_ENVIROMENT.environment];
loginDetails: any[];
loginDetailsStore: Observable<any[]>;
	
constructor(private http: HttpClient,
            private store: Store<AppState>) {
this.loginDetailsStore = this.store.select(STORE_VAL.loggedin_detail);
this.loginDetailsStore.subscribe((val) => {
if (val.length > 0) {
this.loginDetails = val[0];
}
});
}

getQuoteReferenceNumber(party_id?) {
let serviceUrl ;
if (CURRENT_ENVIROMENT.environment === 'localEnvironment') {
    serviceUrl = this.endPoints.startQuoteUrl;
} else {
    if (this.loginDetails && this.loginDetails['customer'].partyId || party_id ) {
        serviceUrl = this.endPoints.startQuoteUrl  + (party_id? party_id : this.loginDetails['customer'].partyId);
        } else {
        serviceUrl = this.endPoints.startQuoteUrl  + 'NA';
        }
}


return this.http.get(serviceUrl)
.pipe(
map((res: any) => {
return res;
})
);
}


}
